// extracted by mini-css-extract-plugin
export default {"root":"Popup_root__boHoa","header":"Popup_header__1hlH7"};